export default __webpack_public_path__ + "static/fargebruk-eksempel3-68d6af966212c40d59426f293c59cdb9.png";